import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetAPInvoiceWorkflows = createModule({
  base: 'GET_ACCOUNT_PAYABLE_INVOICE_WORKFLOWS',
  apiDetails: SERVICE_ENDPOINT.WORKFLOWS,
});

const CreateAPInvoice = createModule({
  base: 'CREATE_ACCOUNT_PAYABLE_INVOICE',
  apiDetails: { ...SERVICE_ENDPOINT.ACCOUNT_PAYABLE_INVOICE, method: 'post' },
  enableNotification: true,
});

const UpdateAPInvoice = createModule({
  base: 'UPDATE_ACCOUNT_PAYABLE_INVOICE',
  apiDetails: { ...SERVICE_ENDPOINT.ACCOUNT_PAYABLE_INVOICE, method: 'put' },
  enableNotification: true,
});

const GetAPInvoice = createModule({
  base: 'GET_ACCOUNT_PAYABLE_INVOICE',
  apiDetails: { ...SERVICE_ENDPOINT.GET_ACCOUNT_PAYABLE_INVOICE({}), method: 'get' },
});

const GetAPInvoiceList = createModule({
  base: 'GET_ACCOUNT_PAYABLE_INVOICE_LIST',
  apiDetails: SERVICE_ENDPOINT.GET_ACCOUNT_PAYABLE_INVOICE_LIST,
});

const UpdateAPInvoiceStatus = createModule({
  base: 'UPDATE_ACCOUNT_PAYABLE_INVOICE_STATUS',
  apiDetails: SERVICE_ENDPOINT.UPDATE_ACCOUNT_PAYABLE_INVOICE_STATUS({}),
  enableNotification: true,
});

const APInvoiceApprovalWorkflow = createModule({
  base: 'ACCOUNT_PAYABLE_INVOICE_APPROVAL_WORKFLOW',
  apiDetails: SERVICE_ENDPOINT.ACCOUNT_PAYABLE_INVOICE_APPROVAL_WORKFLOW,
  enableNotification: true,
});

export {
  CreateAPInvoice, UpdateAPInvoice, GetAPInvoice, GetAPInvoiceList, UpdateAPInvoiceStatus, APInvoiceApprovalWorkflow, GetAPInvoiceWorkflows,
};
